import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';

import { OidcSessionService } from '../auth/oidc-session.service';
import { APP_CONFIG } from '../config/app-config.model';
import { DevSessionService } from './dev/dev-session.service';
import { SessionService } from './session.service';

/**
 * Session provider selection is runtime on AppConfig.mockAuth (R-004) — never
 * on environment.production, because the pipeline builds every environment
 * with the production configuration (D10, build once / promote).
 *
 * mockAuth false selects the real OIDC-backed session (AITH-43); it starts
 * unauthenticated and is derived from validated claims by the auth module.
 */
export function provideSession(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SessionService,
      useFactory: () =>
        inject(APP_CONFIG).mockAuth
          ? new DevSessionService()
          : inject(OidcSessionService),
    },
  ]);
}
